module.exports = __webpack_public_path__ + "media/images/admin/icons/user-minus-f0dcd6e950df9c053462173a7953d870.svg";